import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "app/api";
import { CreateDataPuOSSRequest, CreateDataPuRequest, CreateDataPuResponse, DataInquiryNIBRequest, DataInquiryNIBResponse, DataPu, DataPuRequest, DataPuResponse } from "./types";

export const getsDataInquiryNIB = createAsyncThunk(
    "getsDataInquiryNIB",
    async (data: DataInquiryNIBRequest, thunkAPI) => {
        const config = {
            method: "get",
            url: "pelaku-usaha/inquirynib",
            params: data
        };

        return api(config).then(
            (res: any) => {
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data.message);
            }
        );
    }
);

export const getsDataProfileNIB = createAsyncThunk(
    "getsDataProfileNIB",
    async (data: DataPuRequest, thunkAPI) => {
        const config = {
            method: "get",
            url: "pelaku-usaha/profile",
            params: data
        };

        return api(config).then(
            (res: any) => {
                if (!res.data.GETS_PU.data[0].IdPu) {
                    return thunkAPI.rejectWithValue("Data tidak ditemukan");
                }
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data.message);
            }
        );
    }
);

export const createDataPuNIB = createAsyncThunk(
    "createDataPuNIB",
    async (data: CreateDataPuRequest, thunkAPI) => {
        const config = {
            method: "post",
            url: "pelaku-usaha/profile",
            data: data
        };

        return api(config).then(
            (res: any) => {
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data.message);
            }
        );
    }
);

export const createDataPuNIBOSS = createAsyncThunk(
    "createDataPuNIBOSS",
    async (data: CreateDataPuOSSRequest, thunkAPI) => {
        const config = {
            method: "post",
            url: "pelaku-usaha/profile-oss",
            data: data
        };

        return api(config).then(
            (res: any) => {
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data.message);
            }
        );
    }
);

const DataNIBSlice = createSlice({
    name: "DataNIBSlice",
    initialState: {
        dataInquiry: {
            GETS_INQUIRYNIB: {
                status: 0,
                data: {
                    nib: "",
                    npwpPerseroan: "",
                    namaPerseroan: "",
                    alamatPerseroan: "",
                    dataProyek: [
                        {
                            idProyek: "",
                            kbli: "",
                            uraianUsaha: ""
                        }
                    ],
                }
            }
        } as DataInquiryNIBResponse,
        dataProfile: {
            GETS_PU: {
                data: [] as DataPu[]
            },
        } as DataPuResponse,
        dataCreatePuNIB: {

        } as CreateDataPuResponse,

        isFetching: false,
        isFetchingCreateDataPuNib: false,

        isSuccessProfile: false,
        isSuccessInquiry: false,
        isSuccessCreateDataPuNIB: false,

        isErrorProfile: false,
        isErrorInquiry: false,
        isErrorCreateDataPuNIB: false,

        isAuth: false,
        errorMessage: "" as string,
    },
    reducers: {
        clearStateDataNIBInquiry: (state, action) => {
            state.isFetching = false;
            state.isSuccessInquiry = false;
            state.isErrorInquiry = false;
            state.errorMessage = "";
        },

        clearStateDataNIBProfile: (state, action) => {
            state.isFetching = false;
            state.isSuccessProfile = false;
            state.isErrorProfile = false;
            state.errorMessage = "";
        },
        clearStateCreateDataPuNIB: (state, action) => {
            state.isFetching = false;
            state.isSuccessCreateDataPuNIB = false;
            state.isErrorCreateDataPuNIB = false;
            state.errorMessage = "";
        },
    },
    extraReducers: (builder) => {
        // getsDataInquiryNIB
        builder.addCase(getsDataInquiryNIB.fulfilled, (state, { payload }) => {
            state.isFetching = false;
            state.isSuccessInquiry = true;
            state.dataInquiry = payload;
            return state;
        });
        builder.addCase(getsDataInquiryNIB.rejected, (state, payload: any) => {
            state.isFetching = false;
            state.isErrorInquiry = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(getsDataInquiryNIB.pending, (state, action) => {
            state.isFetching = true;
        });

        // getsDataNIB
        builder.addCase(getsDataProfileNIB.fulfilled, (state, { payload }) => {
            state.isFetching = false;
            state.isSuccessProfile = true;
            state.dataProfile = payload;
            return state;
        });
        builder.addCase(getsDataProfileNIB.rejected, (state, payload: any) => {
            state.isFetching = false;
            state.isErrorProfile = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(getsDataProfileNIB.pending, (state, action) => {
            state.isFetching = true;
        });

        // createDataPuNIB
        builder.addCase(createDataPuNIB.fulfilled, (state, { payload }) => {
            state.isFetchingCreateDataPuNib = false;
            state.isSuccessCreateDataPuNIB = true;
            state.dataCreatePuNIB = payload;
            return state;
        });
        builder.addCase(createDataPuNIB.rejected, (state, payload: any) => {
            state.isFetchingCreateDataPuNib = false;
            state.isErrorCreateDataPuNIB = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(createDataPuNIB.pending, (state, action) => {
            state.isFetchingCreateDataPuNib = true;
        });

        builder.addCase(createDataPuNIBOSS.fulfilled, (state, { payload }) => {
            state.isFetchingCreateDataPuNib = false;
            state.isSuccessCreateDataPuNIB = true;
            state.dataCreatePuNIB = payload;
            return state;
        });
        builder.addCase(createDataPuNIBOSS.rejected, (state, payload: any) => {
            state.isFetchingCreateDataPuNib = false;
            state.isErrorCreateDataPuNIB = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(createDataPuNIBOSS.pending, (state, action) => {
            state.isFetchingCreateDataPuNib = true;
        });

    },
});

export const { clearStateDataNIBInquiry, clearStateDataNIBProfile, clearStateCreateDataPuNIB } = DataNIBSlice.actions;
export default DataNIBSlice.reducer;
